<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrights"><a id="ch00_fm04"></a><a id="page_iv"></a>© 2004 The Johns Hopkins University Press<br/>All rights reserved. Published 2004<br/>Printed in the United States of America on acid-free paper<br/>9 8 7 6 5 4 3 2 1</p>
<p class="copyrights">Some of the profiles, in slightly different form, were published in <em>Civil War News</em> between April 2001 and June 2003. An earlier version of the profile of James M. Cooper was published in the September-October 2001 issue of <em>Military Images</em> magazine.</p>
<p class="copyrights">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218–4363<br/><span class="weblink"><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyrights"><span class="smallcaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="noindent2">Coddington, Ron, 1963-</p>
<p class="indent">Faces of the Civil War: an album of Union soldiers and their stories / Ronald S. Coddington; with a foreword by Michael Fellman.</p>
<p class="indent">        p. cm.<br/>Includes bibliographical references (p.) and index.</p>
<p class="indent"><span class="smallcaps">ISBN</span> 0–8018-7876–4 (alk. paper)</p>
<p class="indent">1. United States — History—Civil War, 1861–1865 — Biography. 2. United States — History—Civil War, 1861–1865 — Portraits. 3. United States. Army— Officers — Biography. 4. United States. Army—Officers — Portraits. 5. Soldiers — United States — Biography. 6. Soldiers—United States — Portraits. I. Title.</p>
<p class="indent"><span class="smallcaps">E</span>467.C63 2004</p>
<p class="indent">973.7′41′0922 — dc22</p>
<p class="attributions">2003018305</p>
<p class="copyrights">A catalog record for this book is available from the British Library.</p>
<p class="copyrights"><em>The frontispiece photograph was taken by James Presley Ball (1825–1904) between 1861 and 1863. The unidentified corporal’s firearm is an Austrian Lorenz musket.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?6155dccf